import { Box } from "../styledSystemUtilities";
import React from "react";

export const Dot = ({ fill, width = "9px" }) => {
    return <Box height={width} width={width} borderRadius={"50%"} backgroundColor={fill} />;
};
